module.exports = __webpack_public_path__ + "images/avatars/male/6.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/6.svg
// module id = 390S
// module chunks = 55